import { render, staticRenderFns } from "./InformationOnVoucherPage.vue?vue&type=template&id=34d055d3"
import script from "./InformationOnVoucherPage.vue?vue&type=script&lang=js"
export * from "./InformationOnVoucherPage.vue?vue&type=script&lang=js"
import style0 from "./InformationOnVoucherPage.vue?vue&type=style&index=0&id=34d055d3&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34d055d3')) {
      api.createRecord('34d055d3', component.options)
    } else {
      api.reload('34d055d3', component.options)
    }
    module.hot.accept("./InformationOnVoucherPage.vue?vue&type=template&id=34d055d3", function () {
      api.rerender('34d055d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/bookingAndTickets/InformationOnVoucherPage.vue"
export default component.exports